import { Link } from "react-router-dom";
import "../styles/pages/project.scss";

export default function Retronet() {
  return (
    <div className="project-page">
      <img src={require("../assets/retronet.png")} alt="Retro Net" />
      <div className="main-content">
        <div>
          <h1 className="title">Retro Net</h1>
          <div className="caption">Time-Travel Through The Web.</div>
        </div>
        <div className="links">
          <div>
            <a
              className="highlight-2"
              href="https://retronet.netlify.app/"
              target="blank"
              tabindex="0"
            >
              <span>Visit Retro Net</span>
            </a>
          </div>
          <div>
            <a
              className="highlight-2"
              href="https://github.com/jbkad/retronet"
              target="blank"
              tabindex="0"
            >
              <span>View source code</span>
            </a>
          </div>
        </div>
        <div className="body">
          <h2 className="heading">Background</h2>
          <p>
            Retro Net was a fun project created for users to experience the
            internet's past, offering a nostalgic journey through time. In an
            era where web design and content have evolved rapidly, Retro Net
            fills a unique niche by allowing users to easily step back in time
            and see their favourite websites as they appeared a decade ago. The
            goal was to make this "time-travel" experience as intuitive and
            enjoyable as possible, harnessing archived data to bring the past to
            life. Retro Net captures the essence of how the online world has
            changed, whether it's YouTube's early simplicity, Wikipedia's
            evolving content, or Reddit's old-school layout.
            <br />
            <br />
            <bold>My specific role on the project</bold>
            <br />
            This was a personal project where I managed all aspects of
            development, from the initial concept planning to the final
            implementation. Specifically, my responsibilities included designing
            and developing the user interface using React.js, integrating
            external APIs such as the Wayback Machine, and ensuring a smooth
            user experience.
          </p>
          <h2 className="heading">Design</h2>
          <p>
            The design of Retro Net focused on delivering a user-friendly
            interface that allowed seamless navigation between different
            websites. The design aimed to recreate a "time travel" atmosphere,
            with the UI kept intentionally clean and simple to echo the styles
            of past web interfaces, providing a familiar yet engaging
            experience. Accessibility was a key consideration in the design
            process, ensuring that the site was fully keyboard accessible. This
            included thoughtful navigation elements and interactive components
            that could be easily accessed without a mouse, enhancing usability
            for all users, including those with disabilities.
          </p>

          <h2 className="heading">Implementation</h2>
          <p>
            Retro Net was implemented using a variety of modern web
            technologies. React.js served as the foundation for building a
            dynamic and responsive user interface. The Wayback Machine API was
            central to the application, providing the archived snapshots of
            popular websites from years gone by. Tailwind CSS was used for
            efficient and modern styling, allowing for a streamlined approach to
            design and rapid prototyping. The application architecture
            emphasised modularity, ensuring that new features could be added
            easily in the future.
          </p>

          <h2 className="heading">
            Outcome, maintainance, and continous improvement
          </h2>
          <p>
            Retro Net successfully met its core objective of creating an
            accessible and enjoyable way for users to explore the internet’s
            history. By blending nostalgic design with modern web technologies,
            it delivers a smooth and engaging experience that resonates with
            users curious about how their favourite sites once looked. Initial
            user feedback has been positive, highlighting the interface’s ease
            of use and the novelty of revisiting archived content.
            <br />
            <br />
            Moving forward, Retro Net is designed with scalability in mind.
            Future improvements may include support for more websites, enhanced
            visual theming to better reflect each historical era, and deeper
            integration with archival sources for improved accuracy and
            coverage. Regular maintenance will focus on ensuring API
            reliability, improving performance, and refining accessibility
            features.
            <br /> <br />
            This project has laid a solid foundation for continued iteration,
            and serves as a practical example of how modern tools can be used to
            creatively repurpose historical web data. As web technologies and
            user needs evolve, Retro Net will continue to adapt, offering new
            ways to explore and appreciate the web’s digital heritage.
          </p>
        </div>
        <br />
        <a href="/#projects" className="highlight-2">
          Back to projects
        </a>
      </div>
    </div>
  );
}
